import React, { Component } from 'react'

import SideBarButton from './SideBarButton';

import './ZenSettings.css'

export default class ZenControlls extends Component {

  _handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.type === 'number' ? Number(target.value) : target.value
    const name = target.name;

    this.props.setSetting({
      [name]: value
    });
  }

  render() {
    const fullSettings = this.props.fullSettings
    const boxExtraClass = fullSettings ? "settings-box-full" : "settings-box-part"
    const fullyCollapsed = this.props.collapsed === "fullyCollapsed"
    const partlyCollapsed = this.props.collapsed === "partlyCollapsed"
    const contentItemClass = fullSettings ? "settings-content-item-full" : "settings-content-item-part"
    const fullContentHeight = fullyCollapsed 
      ? 0 
      : partlyCollapsed 
        ? 46
        : 200 // hardcoded pixel values as 'auto' can't be translated :/
    const boxHeight = partlyCollapsed ? 0 : 140

    return (
      <div className={"settings-wrapper"+(fullyCollapsed?" collapsed":"")} style={{height: fullContentHeight}}>
        <SideBarButton 
          fullText="Zen Settings" 
          smallText="Zen" 
          handleButtonClick={this.props.toggleSettings} 
          fullButton={fullSettings} 
          collapsed={this.props.collapsed} 
        />
        <div className={"settings-box "+boxExtraClass+(partlyCollapsed?" collapsed":"")} style={{height: boxHeight}}>
          <div className="settings-content">
            <form>
              <div className={contentItemClass}>
                <label>
                  {fullSettings ? "Zen Mode" : ""}
                </label>
                <input
                  name="zenMode"
                  type="checkbox"
                  checked={this.props.settings.zenMode}
                  onChange={this._handleInputChange} />
              </div>
              <div className={contentItemClass}>
                <label>
                  {fullSettings ? "# Squares" : ""}
                </label>
                <input
                  name="numSquares"
                  type="number"
                  value={this.props.settings.numSquares}
                  onChange={this._handleInputChange} />
              </div>
              <div className={contentItemClass}>
                <label>
                  {fullSettings ? "Dyn. Sqares" : ""}
                </label>
                <input
                  name="dynamicSquareSize"
                  type="checkbox"
                  checked={this.props.settings.dynamicSquareSize}
                  onChange={this._handleInputChange} />
              </div>
              <div className={contentItemClass}>
                <label>
                  {fullSettings ? "Animate Hof" : ""}
                </label>
                <input
                  name="animatedHof"
                  type="checkbox"
                  checked={this.props.settings.animatedHof}
                  onChange={this._handleInputChange} />
              </div>
              <div className={contentItemClass}>
                <label>
                  {fullSettings ? "Show Mouse" : ""}
                </label>
                <input
                  name="showMouseLine"
                  type="checkbox"
                  checked={this.props.settings.showMouseLine}
                  onChange={this._handleInputChange} />
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}